import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import {ListItem} from '../../../entities/list-item.entity';
import ReducedUser = Backend.App.Resources.Dashboard.Administration.ReducedUser;

@Injectable({providedIn: 'root'})
export class AddableTeamLeadersService extends BaseEndpointService<ReducedUser> {
  protected override endpoint = '/time-tracking/employees/addable-team-leaders';

  public override modelToMultiSelectItem(m: ReducedUser): ListItem & { model: ReducedUser; } {
    return {
      id: m.id,
      text: m.name,
      isDisabled: false,
      model: m,
    }
  }
}
